import request from '@/http/request';

// 获取技术改造列表
export function getTechnicalReformList(params) {
  return request({
    url: '/api/v1/ops/technical_reform/list',
    method: 'get',
    params,
  });
}

export function getPoServiceTypes(params) {
  return request({
    url: '/api/v1/ops/po_service_types',
    method: 'get',
    params,
  });
}

export function getTechnicalReformListAll(params) {
  return request({
    url: '/api/v1/ops/technical_reform/list/all',
    method: 'get',
    params,
  });
}

// 创建技术改造项目
export function createTechnicalReform(data) {
  return request({
    url: '/api/v1/ops/technical_reform/create',
    method: 'post',
    data,
  });
}

// 更新技术改造项目
export function updateTechnicalReform(reformId, data) {
  return request({
    url: `/api/v1/ops/technical_reform/${reformId}`,
    method: 'put',
    data,
  });
}

// 上传技术改造附件
export function uploadTechnicalReformAttachment(reformId, file) {
  const formData = new FormData();
  formData.append('file', file);
  return request({
    url: `/api/v1/ops/technical_reform/${reformId}/attachments`,
    method: 'post',
    data: formData,
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
}

// 审核技术改造项目
export function auditTechnicalReform(reformId, data) {
  return request({
    url: '/api/v1/ops/technical_reform/audit/' + reformId,
    method: 'post',
    data,
  });
}

export function submitProjectSolution(reformId, data) {
  return request({
    url: '/api/v1/ops/technical_reform/solution/' + reformId,
    method: 'post',
    data,
  });
}

export function technicalReformArchive(reformId, data) {
  return request({
    url: '/api/v1/ops/technical_reform/archive/' + reformId,
    method: 'post',
    data,
  });
}
export function technicalReformReject(reformId, data) {
  return request({
    url: '/api/v1/ops/technical_reform/reject/' + reformId,
    method: 'post',
    data,
  });
}

// 删除技术改造项目
export function deleteTechnicalReform(reformId, data) {
  return request({
    url: `/api/v1/ops/technical_reform/${reformId}`,
    method: 'delete',
    data: data,
  });
}
export function updateTechnicalReformRemark(reformId, data) {
  return request({
    url: `/api/v1/ops/technical_reform/${reformId}/remark`,
    method: 'put',
    data
  });
}

// 获取技术改造项目详情
export function getTechnicalReformDetail(reformId) {
  return request({
    url: `/api/v1/ops/technical_reform/detail/${reformId}`,
    method: 'get',
  });
}

export function getTechnical_solution(reformId) {
  return request({
    url: `/api/v1/ops/technical_solution/attachments/${reformId}`,
    method: 'get',
  });
}


// 删除技术改造附件
export function deleteTechnicalReformAttachment(attachmentId) {
  return request({
    url: `/api/v1/ops/technical_reform/attachment/${attachmentId}`,
    method: 'delete',
  });
}

// 获取技术改造日志
export function getReformLogsById(reformId) {
  return request({
    url: `/api/v1/ops/technical_reform/logs/${reformId}`,
    method: 'get',
  });
}


export function deleteTechnicalSolutionAttachment(attachmentId) {
  return request({
    url: `/api/v1/ops/technical_solution/attachment/${attachmentId}`,
    method: 'delete',
  });
}